export default __webpack_public_path__ + "assets/images/b52e9b8b61543127149f07ff107ee8fb.png";